<template>
  <div class='page page__list'>
    <search-bar
      @search="onSearch"
      name="sa_vendcode,sa_vendname,pr_detail,pr_code,sa_code"
      placeholder="输入物料、供应商、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/plm/plm_sample/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.sa_vendname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.sa_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sa_status!='已审核'}"
          >{{item.sa_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  mixins: [list],
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  data() {
    return {
      listUrl: "/api/plm/sample/list",
      // params: {
      //   mode: "DETAIL",
      //   number: 1,
      //   size: 10,
      // },
      filters: [
        {
          type: "date",
          name: "plm_sample.sa_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "sa_statuscode <> 'AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "sa_statuscode = 'AUDITED'"
            },
          ]
        }
      ]
    }
  }
}
</script>